import { Box } from '@mui/material';
import React from 'react';
import { endOfYear, startOfYear } from 'date-fns';
import { flexGap2 } from '../../../../constants/lkCadastr/cadastrStorage';
import CustomInput from '../../../../components/Inputs';
import CustomDatePicker from '../../../../components/CustomDatePicker';
import { useGetReport, getYear } from '../utils';
import { createReportRequest } from '../../../../api/reportApi';
import { fileTypes, report_type, reportTitles } from '../constants';

import { ReportTemplate } from './ReportTemplate';

const initialForm = {
  year: '',
  last_day: null,
};

export function OrganizationsOverdueReport() {
  const getReports = async ({ form }) => {
    try {
      return createReportRequest({
        format_type: fileTypes.xlsx,
        report_type,
        kind: reportTitles.list_organizations_overdue_reporting,
        options: { year: getYear(form.year), date_of_delay: form.last_day },
      });
    } catch (e) {
      console.error(e);
    }
  };

  const changeForm = (setForm, { name, value, form }) => {
    if (name === 'year') setForm({ year: value, last_day: null });
    else setForm({ ...form, [name]: value });
  };

  const {
    form,
    onChange,
    makeRequest,
    clear,
    dateError,
    isCleared,
    setIsCleared,
  } = useGetReport({
    initialForm,
    withDownload: true,
    getReports,
    changeForm,
  });

  const { year, last_day } = form;

  const lastYear = getYear(year);
  const lastDayBounds = lastYear
    ? {
      minDate: startOfYear(new Date(lastYear, 0, 1)),
      maxDate: endOfYear(new Date(lastYear, 0, 1)),
    }
    : {};

  return (
    <ReportTemplate
      downloadOptions={{ disableDownload: !year || !last_day, makeRequest }}
      clear={clear}
      reportTitle="Период принятия отчета"
      visibleClear={year || last_day !== null}
      error={dateError}
    >
      <Box sx={{ ...flexGap2, flexDirection: 'row' }}>
        <CustomInput
          label="Год отчётного периода"
          name="year"
          value={year}
          onChange={onChange}
          type="number"
          maxLength={4}
          placeholder="ГГГГ"
        />
        <CustomDatePicker
          label="Последний день приема"
          name="last_day"
          value={last_day}
          onChange={onChange}
          clearInvalidDate
          isCleared={isCleared}
          setIsCleared={setIsCleared}
          {...lastDayBounds}
        />
      </Box>
    </ReportTemplate>
  );
}
